import { Injectable } from "@angular/core";
import { Router, CanActivate } from "@angular/router";
import { RouteService } from "../core/services";
import { AuthService } from "../services/auth.service";

@Injectable()
export class LoggedGuard implements CanActivate {

    constructor(private auth: AuthService, private routeService: RouteService) { }

    // Return false if the user is not logged in
    canActivate() {
        const isAuthenticated = localStorage.getItem('id_token');
        if (!isAuthenticated) {
            return true;
        } else {
            this.routeService.goToLandingPage();
            return false;
        }
    }
}
